import LegalDocumentPage from "@/components/layout/LegalDocumentPage";
import { CONTACT_EMAIL } from "@/config/site";

const LAST_UPDATED = "February 22, 2026";

const sections = [
  {
    title: "1. What Cookies Are",
    paragraphs: [
      "Cookies are small text files placed on your device when you visit a website. They can help websites function, improve security, and remember preferences.",
    ],
  },
  {
    title: "2. Cookies We Use",
    paragraphs: [
      "As of the last updated date above, this website is designed to operate without analytics or advertising cookies. We only use technical mechanisms needed for core site operation and security.",
    ],
  },
  {
    title: "3. Third-Party Services",
    paragraphs: [
      "If you click external links (for example WhatsApp or other third-party platforms), those services may place their own cookies once you leave this website. Their cookie policies apply independently.",
    ],
  },
  {
    title: "4. Managing Cookies",
    bullets: [
      "You can control or delete cookies through your browser settings.",
      "You can block all cookies, but some website features may not work as intended.",
      "You can clear existing cookies already stored on your device.",
    ],
  },
  {
    title: "5. Changes to This Policy",
    paragraphs: [
      "If our cookie usage changes, this policy will be updated and the revision date will be amended on this page.",
    ],
  },
  {
    title: "6. Contact",
    paragraphs: [
      `For questions about this Cookie Policy, contact ${CONTACT_EMAIL}.`,
    ],
  },
];

export default function CookiePolicy() {
  return (
    <LegalDocumentPage
      title="Cookie Policy"
      lastUpdated={LAST_UPDATED}
      intro="This policy explains how Specialist Dental London uses cookies and similar technologies on this website."
      sections={sections}
      testIdPrefix="cookie-policy"
    />
  );
}
